module.exports = __webpack_public_path__ + "img/Service-ability-01.9b2f4f92.png";